import { alpha } from '@mui/material';

export const styles = {
  appBar: {
    width: '100%',
    height: '64px',
    background: '#fff',
    borderBottom: `1px solid ${alpha('#000', 0.12)}`,
    boxShadow: 'none',
  },
  content: {
    width: 'calc(100vw - 265px)',
    height: '100%',
    marginLeft: '248px',
    marginTop: '64px',
    flexGrow: 1,
  },
};
